// Generated by scripts/update-international-catalogues.py; do not edit.
export const COUNTRY_CATALOGUE = [
    {
        code: 'AF',
        aliases: [
            'AFG',
            '004',
            'Afghanistan',
            'Afganistán',
            'Afganistan',
            'Islamitisch Emiraat Afghanistan',
            'Afeganistão',
        ],
    },
    {
        code: 'AL',
        aliases: [
            'ALB',
            '008',
            'Albanien',
            'Albania',
            'Albanie',
            'Arnavutluk',
            'Republiek Albanië',
            'Albanië',
            'Albânia',
        ],
    },
    {
        code: 'DZ',
        aliases: [
            'DZA',
            '012',
            'Algerien',
            'Algeria',
            'Algérie',
            'Argelia',
            'Cezayir',
            'Democratische Volksrepubliek Algerije',
            'Algerije',
            'Argélia',
        ],
    },
    {
        code: 'AS',
        aliases: [
            'ASM',
            '016',
            'Amerikanisch-Samoa',
            'American Samoa',
            'Samoa américaines',
            'Samoa Americana',
            'Amerikan Samoası',
            'Samoa Americane',
            'Amerikaans-Samoa',
        ],
    },
    { code: 'AD', aliases: ['AND', '020', 'Andorra', 'Andorre', 'Vorstendom Andorra'] },
    { code: 'AO', aliases: ['AGO', '024', 'Angola', 'Republiek Angola'] },
    { code: 'AI', aliases: ['AIA', '660', 'Anguilla', 'Anguila'] },
    {
        code: 'AQ',
        aliases: [
            'ATA',
            '010',
            'Antarktis',
            'Antarctica',
            'Antarctique',
            'Antártida',
            'Antarktika',
            'Antartide',
        ],
    },
    {
        code: 'AG',
        aliases: [
            'ATG',
            '028',
            'Antigua und Barbuda',
            'Antigua and Barbuda',
            'Antigua-et-Barbuda',
            'Antigua y Barbuda',
            'Antigua ve Barbuda',
            'Antigua e Barbuda',
            'Antigua en Barbuda',
            'Antígua e Barbuda',
        ],
    },
    {
        code: 'AR',
        aliases: [
            'ARG',
            '032',
            'Argentinien',
            'Argentina',
            'Argentine',
            'Arjantin',
            'Argentijnse Republiek',
            'Argentinië',
        ],
    },
    {
        code: 'AM',
        aliases: [
            'ARM',
            '051',
            'Armenien',
            'Armenia',
            'Arménie',
            'Ermenistan',
            'Republiek Armenië',
            'Armenië',
            'Arménia',
        ],
    },
    { code: 'AW', aliases: ['ABW', '533', 'Aruba'] },
    {
        code: 'AU',
        aliases: [
            'AUS',
            '036',
            'Australien',
            'Australia',
            'Australie',
            'Avustralya',
            'Gemenebest van Australië',
            'Australië',
            'Austrália',
        ],
    },
    {
        code: 'AT',
        aliases: [
            'AUT',
            '040',
            'Österreich',
            'Austria',
            'Autriche',
            'Avusturya',
            'Republiek Oostenrijk',
            'Oostenrijk',
            'Áustria',
        ],
    },
    {
        code: 'AZ',
        aliases: [
            'AZE',
            '031',
            'Aserbaidschan',
            'Azerbaijan',
            'Azerbaïdjan',
            'Azerbaiyán',
            'Azerbaycan',
            'Azerbaigian',
            'Republiek Azerbeidzjan',
            'Azerbeidzjan',
            'Azerbaijão',
        ],
    },
    {
        code: 'BS',
        aliases: ['BHS', '044', 'Bahamas', 'Bahamalar', "Gemenebest van de Bahama's", "Bahama's"],
    },
    {
        code: 'BH',
        aliases: ['BHR', '048', 'Bahrain', 'Bahreïn', 'Bahrein', 'Bahreyn', 'Koninkrijk Bahrein'],
    },
    {
        code: 'BD',
        aliases: ['BGD', '050', 'Bangladesch', 'Bangladesh', 'Bangladeş', 'Volksrepubliek Bangladesh'],
    },
    { code: 'BB', aliases: ['BRB', '052', 'Barbados', 'Barbade'] },
    {
        code: 'BY',
        aliases: [
            'BLR',
            '112',
            'Belarus',
            'Biélorussie',
            'Bielorrusia',
            'Beyaz Rusya',
            'Bielorussia',
            'Republiek Wit-Rusland',
            'Wit-Rusland',
            'Bielorrússia',
        ],
    },
    {
        code: 'BE',
        aliases: [
            'BEL',
            '056',
            'Belgien',
            'Belgium',
            'Belgique',
            'Bélgica',
            'Belçika',
            'Belgio',
            'Koninkrijk België',
            'België',
        ],
    },
    { code: 'BZ', aliases: ['BLZ', '084', 'Belize', 'Belice'] },
    { code: 'BJ', aliases: ['BEN', '204', 'Benin', 'Bénin', 'Republiek Benin', 'Benim'] },
    { code: 'BM', aliases: ['BMU', '060', 'Bermuda', 'Bermudes', 'Bermudas'] },
    {
        code: 'BT',
        aliases: ['BTN', '064', 'Bhutan', 'Bhoutan', 'Bután', 'Butan', 'Koninkrijk Bhutan', 'Butão'],
    },
    {
        code: 'BO',
        aliases: [
            'BOL',
            '068',
            'Bolivien',
            'Bolivia',
            'Bolivie',
            'Bolivya',
            'Plurinationale Staat Bolivia',
            'Bolivië',
            'Bolívia',
        ],
    },
    {
        code: 'BA',
        aliases: [
            'BIH',
            '070',
            'Bosnien und Herzegowina',
            'Bosnia and Herzegovina',
            'Bosnie-Herzégovine',
            'Bosnia y Herzegovina',
            'Bosna Hersek',
            'Bosnia ed Erzegovina',
            'Bosnië en Herzegovina',
            'Bosnië-Herzegovina',
            'Bósnia-Herzegovina',
        ],
    },
    { code: 'BW', aliases: ['BWA', '072', 'Botswana', 'Botsvana', 'Republiek Botswana', 'Botsuana'] },
    {
        code: 'BV',
        aliases: [
            'BVT',
            '074',
            'Bouvetinsel',
            'Bouvet Island',
            'Île Bouvet',
            'Isla Bouvet',
            'Bouvet Adası',
            'Isola Bouvet',
            'Bouvet Eiland',
            'Ilha Bouvet',
        ],
    },
    {
        code: 'BR',
        aliases: [
            'BRA',
            '076',
            'Brasilien',
            'Brazil',
            'Brésil',
            'Brasil',
            'Brezilya',
            'Brasile',
            'Federale Republiek Brazilië',
            'Brazilië',
        ],
    },
    {
        code: 'IO',
        aliases: [
            'IOT',
            '086',
            'Britisches Territorium im Indischen Ozean',
            'British Indian Ocean Territory',
            'Océan Indien Britannique',
            'Territorio Británico del Océano Índico',
            'Britanya Hint Okyanusu Toprakları',
            "Territori Britannici dell'Oceano Indiano",
            'Brits Indische oceaan',
            'Território Britânico do Oceano Índico',
        ],
    },
    { code: 'BN', aliases: ['BRN', '096', 'Brunei Darussalam', 'Brunei'] },
    {
        code: 'BG',
        aliases: [
            'BGR',
            '100',
            'Bulgarien',
            'Bulgaria',
            'Bulgarie',
            'Bulgaristan',
            'Republiek Bulgarije',
            'Bulgarije',
            'Bulgária',
        ],
    },
    { code: 'BF', aliases: ['BFA', '854', 'Burkina Faso'] },
    { code: 'BI', aliases: ['BDI', '108', 'Burundi', 'Republiek Burundi'] },
    {
        code: 'KH',
        aliases: [
            'KHM',
            '116',
            'Kambodscha',
            'Cambodia',
            'Cambodge',
            'Camboya',
            'Kamboçya',
            'Cambogia',
            'Koninkrijk Cambodja',
            'Cambodja',
            'Camboja',
        ],
    },
    {
        code: 'CM',
        aliases: [
            'CMR',
            '120',
            'Kamerun',
            'Cameroon',
            'Cameroun',
            'Camerún',
            'Camerun',
            'Republiek Kameroen',
            'Kameroen',
            'Camarões',
        ],
    },
    { code: 'CA', aliases: ['CAN', '124', 'Kanada', 'Canada', 'Canadá'] },
    {
        code: 'CV',
        aliases: [
            'CPV',
            '132',
            'Kap Verde',
            'Cape Verde',
            'Cap-Vert',
            'Cabo Verde',
            'Capo Verde',
            'Republiek Kaapverdië',
            'Kaapverdië',
        ],
    },
    {
        code: 'KY',
        aliases: [
            'CYM',
            '136',
            'Kaimaninseln',
            'Cayman Islands',
            'Îles Caïmans',
            'Islas Caimán',
            'Cayman Adaları',
            'Isole Cayman',
            'Kaaimaneilanden',
            'Ilhas Caimão',
        ],
    },
    {
        code: 'CF',
        aliases: [
            'CAF',
            '140',
            'Zentralafrikanische Republik',
            'Central African Republic',
            'République Centrafricaine',
            'República Centroafricana',
            'Orta Afrika Cumhuriyeti',
            'Repubblica Centrafricana',
            'Centraal-Afrikaanse Republiek',
            'República Centro-Africana',
        ],
    },
    {
        code: 'TD',
        aliases: [
            'TCD',
            '148',
            'Tschad',
            'Chad',
            'Tchad',
            'Çad',
            'Ciad',
            'Republiek Tsjaad',
            'Tsjaad',
            'Chade',
        ],
    },
    { code: 'CL', aliases: ['CHL', '152', 'Chile', 'Chili', 'Şili', 'Cile', 'Republiek Chili'] },
    {
        code: 'CN',
        aliases: [
            'CHN',
            '156',
            'China',
            "People's Republic of China",
            'Chine',
            'Çin',
            'Cina',
            'Volksrepubliek China',
        ],
    },
    {
        code: 'CX',
        aliases: [
            'CXR',
            '162',
            'Weihnachtsinsel',
            'Christmas Island',
            'Île Christmas',
            'Isla de Navidad',
            'Christmas Adası',
            'Isola del Natale',
            'Christmaseiland',
            'Kersteiland',
            'Ilha de Natal',
        ],
    },
    {
        code: 'CC',
        aliases: [
            'CCK',
            '166',
            'Kokosinseln',
            'Cocos (Keeling) Islands',
            'Îles Cocos',
            'Islas Cocos (Keeling)',
            'Cocos (Keeling) Adaları',
            'Isole Cocos e Keeling',
            'Cocoseilanden',
            'Ilhas Cocos (Keeling)',
        ],
    },
    {
        code: 'CO',
        aliases: [
            'COL',
            '170',
            'Kolumbien',
            'Colombia',
            'Colombie',
            'Kolombiya',
            'Republiek Colombia',
            'Colômbia',
        ],
    },
    {
        code: 'KM',
        aliases: [
            'COM',
            '174',
            'Komoren',
            'Comoros',
            'Comores',
            'Comoras',
            'Komorlar',
            'Comore',
            'Unie der Comoren',
            'Comoren',
        ],
    },
    {
        code: 'CG',
        aliases: [
            'COG',
            '178',
            'Republik Kongo',
            'Republic of the Congo',
            'Congo',
            'République du Congo',
            'Kongo - Brazavil',
            'Repubblica del Congo',
            'Republiek Congo',
            'Congo-Brazzaville',
            'República Democrática do Congo',
        ],
    },
    {
        code: 'CD',
        aliases: [
            'COD',
            '180',
            'Kongo',
            'Democratic Republic of the Congo',
            'Congo',
            'République démocratique du Congo',
            'Congo (República Democrática del)',
            'Kongo - Kinşasa',
            'Repubblica Democratica del Congo',
            'Democratische Republiek Congo',
            'Congo-Kinshasa',
            'República Popular do Congo',
        ],
    },
    {
        code: 'CK',
        aliases: [
            'COK',
            '184',
            'Cookinseln',
            'Cook Islands',
            'Îles Cook',
            'Islas Cook',
            'Cook Adaları',
            'Isole Cook',
            'Cookeilanden',
            'Ilhas Cook',
        ],
    },
    { code: 'CR', aliases: ['CRI', '188', 'Costa Rica', 'Kosta Rika', 'Republiek Costa Rica'] },
    {
        code: 'CI',
        aliases: [
            'CIV',
            '384',
            'Elfenbeinküste',
            "Cote d'Ivoire",
            "Côte d'Ivoire",
            'Ivory Coast',
            "Côte-d'Ivoire",
            'Costa de Marfil',
            'Fildişi Sahili',
            "Costa d'Avorio",
            'Republiek Ivoorkust',
            'Ivoorkust',
            'Costa do Marfim',
        ],
    },
    {
        code: 'HR',
        aliases: [
            'HRV',
            '191',
            'Kroatien',
            'Croatia',
            'Croatie',
            'Croacia',
            'Hırvatistan',
            'Croazia',
            'Republiek Kroatië',
            'Kroatië',
            'Croácia',
        ],
    },
    { code: 'CU', aliases: ['CUB', '192', 'Kuba', 'Cuba', 'Küba', 'Republiek Cuba'] },
    {
        code: 'CY',
        aliases: [
            'CYP',
            '196',
            'Zypern',
            'Cyprus',
            'Chypre',
            'Chipre',
            'Güney Kıbrıs Rum Kesimi',
            'Cipro',
            'Republiek Cyprus',
        ],
    },
    {
        code: 'CZ',
        aliases: [
            'CZE',
            '203',
            'Tschechische Republik',
            'Tschechien',
            'Czech Republic',
            'Czechia',
            'République Tchèque',
            'República Checa',
            'Çek Cumhuriyeti',
            'Repubblica Ceca',
            'Tsjechische Republiek',
            'Tsjechië',
            'Chéquia',
        ],
    },
    {
        code: 'DK',
        aliases: [
            'DNK',
            '208',
            'Dänemark',
            'Denmark',
            'Danemark',
            'Dinamarca',
            'Danimarka',
            'Danimarca',
            'Koninkrijk Denemarken',
            'Denemarken',
        ],
    },
    {
        code: 'DJ',
        aliases: [
            'DJI',
            '262',
            'Dschibuti',
            'Djibouti',
            'Yibuti',
            'Cibuti',
            'Gibuti',
            'Republiek Djibouti',
        ],
    },
    {
        code: 'DM',
        aliases: ['DMA', '212', 'Dominica', 'Dominique', 'Dominika', 'Gemenebest Dominica'],
    },
    {
        code: 'DO',
        aliases: [
            'DOM',
            '214',
            'Dominikanische Republik',
            'Dominican Republic',
            'République Dominicaine',
            'República Dominicana',
            'Dominik Cumhuriyeti',
            'Repubblica Dominicana',
            'Dominicaanse Republiek',
        ],
    },
    {
        code: 'EC',
        aliases: ['ECU', '218', 'Ecuador', 'Équateur', 'Ekvador', 'Republiek Ecuador', 'Equador'],
    },
    {
        code: 'EG',
        aliases: [
            'EGY',
            '818',
            'Ägypten',
            'Egypt',
            'Égypte',
            'Egipto',
            'Mısır',
            'Egitto',
            'Arabische Republiek Egypte',
            'Egypte',
            'Egito',
        ],
    },
    { code: 'SV', aliases: ['SLV', '222', 'El Salvador', 'Republiek El Salvador'] },
    {
        code: 'GQ',
        aliases: [
            'GNQ',
            '226',
            'Äquatorialguinea',
            'Equatorial Guinea',
            'Guinée équatoriale',
            'Guinea Ecuatorial',
            'Ekvator Ginesi',
            'Guinea Equatoriale',
            'Republiek Equatoriaal-Guinea',
            'Equatoriaal-Guinea',
            'Guiné Equatorial',
        ],
    },
    {
        code: 'ER',
        aliases: ['ERI', '232', 'Eritrea', 'Érythrée', 'Eritre', 'Staat Eritrea', 'Eritreia'],
    },
    {
        code: 'EE',
        aliases: [
            'EST',
            '233',
            'Estland',
            'Estonia',
            'Estonie',
            'Estonya',
            'Republiek Estland',
            'Estónia',
        ],
    },
    {
        code: 'ET',
        aliases: [
            'ETH',
            '231',
            'Äthiopien',
            'Ethiopia',
            'Éthiopie',
            'Etiopía',
            'Etiyopya',
            'Etiopia',
            'Federale Democratische Republiek Ethiopië',
            'Ethiopië',
            'Etiópia',
        ],
    },
    {
        code: 'FK',
        aliases: [
            'FLK',
            '238',
            'Falklandinseln',
            'Falkland Islands (Malvinas)',
            'Îles Malouines',
            'Islas Malvinas',
            'Falkland Adaları',
            'Isole Falkland',
            'Falklandeilanden',
            'Ilhas Malvinas',
        ],
    },
    {
        code: 'FO',
        aliases: [
            'FRO',
            '234',
            'Färöer',
            'Faroe Islands',
            'Îles Féroé',
            'Islas Feroe',
            'Faroe Adaları',
            'Isole Fær Øer',
            'Faeröer',
            'Ilhas Faroé',
        ],
    },
    { code: 'FJ', aliases: ['FJI', '242', 'Fidschi', 'Fiji', 'Fidji', 'Figi', 'Republiek Fiji'] },
    {
        code: 'FI',
        aliases: [
            'FIN',
            '246',
            'Finnland',
            'Finland',
            'Finlande',
            'Finlandia',
            'Finlandiya',
            'Republiek Finland',
            'Finlândia',
        ],
    },
    {
        code: 'FR',
        aliases: [
            'FRA',
            '250',
            'Frankreich',
            'France',
            'Francia',
            'Fransa',
            'Franse Republiek',
            'Frankrijk',
            'França',
        ],
    },
    {
        code: 'GF',
        aliases: [
            'GUF',
            '254',
            'Französisch-Guayana',
            'French Guiana',
            'Guyane française',
            'Guayana Francesa',
            'Fransız Guyanası',
            'Guyana Francese',
            'Frans-Guyana',
            'Guiana Francesa',
        ],
    },
    {
        code: 'PF',
        aliases: [
            'PYF',
            '258',
            'Französisch-Polynesien',
            'French Polynesia',
            'Polynésie française',
            'Polinesia Francesa',
            'Fransız Polinezyası',
            'Polinesia Francese',
            'Frans-Polynesië',
            'Polinésia Francesa',
        ],
    },
    {
        code: 'TF',
        aliases: [
            'ATF',
            '260',
            'Französische Süd- und Antarktisgebiete',
            'French Southern Territories',
            'Terres australes françaises',
            'Tierras Australes Francesas',
            'Fransız Güney Toprakları',
            'Territori Francesi del Sud',
            'Franse Zuidelijke Gebieden',
            'Terras Austrais e Antárticas Francesas',
        ],
    },
    { code: 'GA', aliases: ['GAB', '266', 'Gabun', 'Gabon', 'Gabón', 'Republiek Gabon', 'Gabão'] },
    {
        code: 'GM',
        aliases: [
            'GMB',
            '270',
            'Gambia',
            'Republic of The Gambia',
            'The Gambia',
            'Gambie',
            'Gambiya',
            'Republiek Gambia',
            'Gâmbia',
        ],
    },
    {
        code: 'GE',
        aliases: ['GEO', '268', 'Georgien', 'Georgia', 'Géorgie', 'Gürcistan', 'Georgië', 'Geórgia'],
    },
    {
        code: 'DE',
        aliases: [
            'DEU',
            '276',
            'Deutschland',
            'Germany',
            'Allemagne',
            'Alemania',
            'Almanya',
            'Germania',
            'Bondsrepubliek Duitsland',
            'Duitsland',
            'Alemanha',
        ],
    },
    { code: 'GH', aliases: ['GHA', '288', 'Ghana', 'Gana', 'Republiek Ghana'] },
    { code: 'GI', aliases: ['GIB', '292', 'Gibraltar', 'Cebelitarık', 'Gibilterra'] },
    {
        code: 'GR',
        aliases: [
            'GRC',
            '300',
            'Griechenland',
            'Greece',
            'Grèce',
            'Grecia',
            'Yunanistan',
            'Helleense Republiek',
            'Griekenland',
            'Grécia',
        ],
    },
    {
        code: 'GL',
        aliases: ['GRL', '304', 'Grönland', 'Greenland', 'Groenland', 'Groenlandia', 'Gronelândia'],
    },
    { code: 'GD', aliases: ['GRD', '308', 'Grenada', 'Grenade', 'Granada'] },
    { code: 'GP', aliases: ['GLP', '312', 'Guadeloupe', 'Guadalupe', 'Guadalupa'] },
    { code: 'GU', aliases: ['GUM', '316', 'Guam'] },
    { code: 'GT', aliases: ['GTM', '320', 'Guatemala', 'Republiek Guatemala'] },
    { code: 'GN', aliases: ['GIN', '324', 'Guinea', 'Guinée', 'Gine', 'Republiek Guinee', 'Guiné'] },
    {
        code: 'GW',
        aliases: [
            'GNB',
            '624',
            'Guinea-Bissau',
            'Guinée-Bissau',
            'Guinea Bissau',
            'Gine-Bissau',
            'Republiek Guinee-Bissau',
            'Guinee-Bissau',
            'Guiné-Bissau',
        ],
    },
    { code: 'GY', aliases: ['GUY', '328', 'Guyana', 'Coöperatieve Republiek Guyana', 'Guiana'] },
    { code: 'HT', aliases: ['HTI', '332', 'Haiti', 'Haïti', 'Haití', 'Republiek Haïti'] },
    {
        code: 'HM',
        aliases: [
            'HMD',
            '334',
            'Heard und McDonaldinseln',
            'Heard Island and McDonald Islands',
            'Îles Heard-et-MacDonald',
            'Heard e Islas McDonald',
            'Heard Adası ve McDonald Adaları',
            'Isole Heard e McDonald',
            'Heard en McDonaldeilanden',
            'Ilha Heard e Ilhas McDonald',
        ],
    },
    {
        code: 'VA',
        aliases: [
            'VAT',
            '336',
            'Vatikanstadt',
            'Holy See (Vatican City State)',
            'Saint-Siège (Vatican)',
            'Santa Sede',
            'Vatikan',
            'Città del Vaticano',
            'Vaticaanstad',
            'Santa Sé',
        ],
    },
    { code: 'HN', aliases: ['HND', '340', 'Honduras', 'Republiek Honduras'] },
    { code: 'HK', aliases: ['HKG', '344', 'Hongkong', 'Hong Kong', 'Çin Hong Kong ÖYB'] },
    {
        code: 'HU',
        aliases: [
            'HUN',
            '348',
            'Ungarn',
            'Hungary',
            'Hongrie',
            'Hungría',
            'Macaristan',
            'Ungheria',
            'Hongaarse Republiek',
            'Hongarije',
            'Hungria',
        ],
    },
    {
        code: 'IS',
        aliases: [
            'ISL',
            '352',
            'Island',
            'Iceland',
            'Islande',
            'Islandia',
            'İzlanda',
            'Islanda',
            'IJslandse Republiek',
            'IJsland',
            'Islândia',
        ],
    },
    {
        code: 'IN',
        aliases: ['IND', '356', 'Indien', 'India', 'Inde', 'Hindistan', 'Republiek India', 'Índia'],
    },
    {
        code: 'ID',
        aliases: [
            'IDN',
            '360',
            'Indonesien',
            'Indonesia',
            'Indonésie',
            'Endonezya',
            'Republiek Indonesië',
            'Indonesië',
            'Indonésia',
        ],
    },
    {
        code: 'IR',
        aliases: [
            'IRN',
            '364',
            'Iran',
            'Islamic Republic of Iran',
            'Irán',
            'República Islámica de Irán',
            'İran',
            'Islamitische Republiek Iran',
            'Irão',
        ],
    },
    { code: 'IQ', aliases: ['IRQ', '368', 'Irak', 'Iraq', 'Republiek Irak', 'Iraque'] },
    {
        code: 'IE',
        aliases: [
            'IRL',
            '372',
            'Irland',
            'Ireland',
            'Irlande',
            'Irlanda',
            'İrlanda',
            'Ierse Republiek',
            'Ierland',
        ],
    },
    { code: 'IL', aliases: ['ISR', '376', 'Israel', 'Israël', 'İsrail', 'Israele', 'Staat Israël'] },
    {
        code: 'IT',
        aliases: [
            'ITA',
            '380',
            'Italien',
            'Italy',
            'Italie',
            'Italia',
            'İtalya',
            'Italiaanse Republiek',
            'Italië',
            'Itália',
        ],
    },
    { code: 'JM', aliases: ['JAM', '388', 'Jamaika', 'Jamaica', 'Jamaïque', 'Giamaica'] },
    {
        code: 'JP',
        aliases: ['JPN', '392', 'Japan', 'Japon', 'Japón', 'Japonya', 'Giappone', 'Japão'],
    },
    {
        code: 'JO',
        aliases: [
            'JOR',
            '400',
            'Jordanien',
            'Jordan',
            'Jordanie',
            'Jordania',
            'Ürdün',
            'Giordania',
            'Hasjemitisch Koninkrijk Jordanië',
            'Jordanië',
            'Jordânia',
        ],
    },
    {
        code: 'KZ',
        aliases: [
            'KAZ',
            '398',
            'Kasachstan',
            'Kazakhstan',
            'Kazajistán',
            'Kazakistan',
            'Republiek Kazachstan',
            'Kazachstan',
            'Cazaquistão',
        ],
    },
    { code: 'KE', aliases: ['KEN', '404', 'Kenia', 'Kenya', 'Republiek Kenia', 'Quénia'] },
    { code: 'KI', aliases: ['KIR', '296', 'Kiribati', 'Republiek Kiribati', 'Quiribati'] },
    {
        code: 'KP',
        aliases: [
            'PRK',
            '408',
            'Nordkorea',
            'North Korea',
            'Corée du Nord',
            'República Popular Democrática de Corea',
            'Kuzey Kore',
            'Corea del Nord',
            'Democratische Volksrepubliek Korea',
            'Noord-Korea',
            'Coreia do Norte',
        ],
    },
    {
        code: 'KR',
        aliases: [
            'KOR',
            '410',
            'Südkorea',
            'South Korea',
            'Korea, Republic of',
            'Republic of Korea',
            'Corée du Sud',
            'República de Corea',
            'Güney Kore',
            'Corea del Sud',
            'Republiek Korea',
            'Zuid-Korea',
            'Coreia do Sul',
        ],
    },
    {
        code: 'KW',
        aliases: ['KWT', '414', 'Kuwait', 'Koweït', 'Kuveyt', 'Staat Koeweit', 'Koeweit', 'Koweit'],
    },
    {
        code: 'KG',
        aliases: [
            'KGZ',
            '417',
            'Kirgisistan',
            'Kyrgyzstan',
            'Kirghizistan',
            'Kirguistán',
            'Kırgızistan',
            'Kirgizische Republiek',
            'Kirgizië',
            'Quirguistão',
        ],
    },
    {
        code: 'LA',
        aliases: [
            'LAO',
            '418',
            'Laos',
            "Lao People's Democratic Republic",
            'República Democrática Popular de Lao',
            'Lao Democratische Volksrepubliek',
        ],
    },
    {
        code: 'LV',
        aliases: [
            'LVA',
            '428',
            'Lettland',
            'Latvia',
            'Lettonie',
            'Letonia',
            'Letonya',
            'Lettonia',
            'Republiek Letland',
            'Letland',
            'Letónia',
        ],
    },
    {
        code: 'LB',
        aliases: [
            'LBN',
            '422',
            'Libanon',
            'Lebanon',
            'Liban',
            'Líbano',
            'Lübnan',
            'Libano',
            'Libanese Republiek',
        ],
    },
    { code: 'LS', aliases: ['LSO', '426', 'Lesotho', 'Lesoto', 'Koninkrijk Lesotho'] },
    { code: 'LR', aliases: ['LBR', '430', 'Liberia', 'Libéria', 'Liberya', 'Republiek Liberia'] },
    {
        code: 'LY',
        aliases: ['LBY', '434', 'Libyen', 'Libya', 'Libye', 'Libia', 'Staat Libië', 'Libië', 'Líbia'],
    },
    { code: 'LI', aliases: ['LIE', '438', 'Liechtenstein', 'Vorstendom Liechtenstein'] },
    {
        code: 'LT',
        aliases: [
            'LTU',
            '440',
            'Litauen',
            'Lithuania',
            'Lituanie',
            'Lituania',
            'Litvanya',
            'Republiek Litouwen',
            'Litouwen',
            'Lituânia',
        ],
    },
    {
        code: 'LU',
        aliases: [
            'LUX',
            '442',
            'Luxemburg',
            'Luxembourg',
            'Luxemburgo',
            'Lüksemburg',
            'Lussemburgo',
            'Groothertogdom Luxemburg',
        ],
    },
    { code: 'MO', aliases: ['MAC', '446', 'Macao', 'Çin Makao ÖYB', 'Macau'] },
    {
        code: 'MG',
        aliases: ['MDG', '450', 'Madagaskar', 'Madagascar', 'Republiek Madagaskar', 'Madagáscar'],
    },
    {
        code: 'MW',
        aliases: ['MWI', '454', 'Malawi', 'Malaui', 'Malavi', 'Republiek Malawi', 'Maláui'],
    },
    {
        code: 'MY',
        aliases: [
            'MYS',
            '458',
            'Malaysia',
            'Malaisie',
            'Malasia',
            'Malezya',
            'Malesia',
            'Maleisië',
            'Malásia',
        ],
    },
    {
        code: 'MV',
        aliases: [
            'MDV',
            '462',
            'Malediven',
            'Maldives',
            'Maldivas',
            'Maldivler',
            'Maldive',
            'Republiek der Maldiven',
            'Maldiven',
        ],
    },
    { code: 'ML', aliases: ['MLI', '466', 'Mali', 'Malí', 'Republiek Mali'] },
    { code: 'MT', aliases: ['MLT', '470', 'Malta', 'Malte', 'Republiek Malta'] },
    {
        code: 'MH',
        aliases: [
            'MHL',
            '584',
            'Marshallinseln',
            'Marshall Islands',
            'Îles Marshall',
            'Islas Marshall',
            'Marshall Adaları',
            'Isole Marshall',
            'Republiek der Marshalleilanden',
            'Marshalleilanden',
            'Ilhas Marshall',
        ],
    },
    { code: 'MQ', aliases: ['MTQ', '474', 'Martinique', 'Martinica', 'Martinik'] },
    {
        code: 'MR',
        aliases: [
            'MRT',
            '478',
            'Mauretanien',
            'Mauritania',
            'Mauritanie',
            'Moritanya',
            'Islamitische Republiek Mauritanië',
            'Mauritanië',
            'Mauritânia',
        ],
    },
    {
        code: 'MU',
        aliases: ['MUS', '480', 'Mauritius', 'Maurice', 'Mauricio', 'Republiek Mauritius', 'Maurícia'],
    },
    { code: 'YT', aliases: ['MYT', '175', 'Mayotte'] },
    {
        code: 'MX',
        aliases: [
            'MEX',
            '484',
            'Mexiko',
            'Mexico',
            'Mexique',
            'México',
            'Meksika',
            'Messico',
            'Verenigde Mexicaanse Staten',
        ],
    },
    {
        code: 'FM',
        aliases: [
            'FSM',
            '583',
            'Mikronesien',
            'Micronesia, Federated States of',
            'Micronésie',
            'Micronesia',
            'Mikronezya',
            'Stati Federati di Micronesia',
            'Federale Staten van Micronesië',
            'Micronesië',
            'Micronésia',
        ],
    },
    {
        code: 'MD',
        aliases: [
            'MDA',
            '498',
            'Moldawien',
            'Moldova, Republic of',
            'Moldavie',
            'Moldavia',
            'Moldova',
            'Republiek Moldavië',
            'Moldavië',
            'Moldávia',
        ],
    },
    { code: 'MC', aliases: ['MCO', '492', 'Monaco', 'Mónaco', 'Monako', 'Vorstendom Monaco'] },
    {
        code: 'MN',
        aliases: [
            'MNG',
            '496',
            'Mongolei',
            'Mongolia',
            'Mongolie',
            'Moğolistan',
            'Mongolië',
            'Mongólia',
        ],
    },
    { code: 'MS', aliases: ['MSR', '500', 'Montserrat', 'Monserrate'] },
    {
        code: 'MA',
        aliases: [
            'MAR',
            '504',
            'Marokko',
            'Morocco',
            'Maroc',
            'Marruecos',
            'Fas',
            'Marocco',
            'Koninkrijk Marokko',
            'Marrocos',
        ],
    },
    {
        code: 'MZ',
        aliases: [
            'MOZ',
            '508',
            'Mosambik',
            'Mozambique',
            'Mozambik',
            'Mozambico',
            'Republiek Mozambique',
            'Moçambique',
        ],
    },
    {
        code: 'MM',
        aliases: [
            'MMR',
            '104',
            'Myanmar',
            'Myanmar (Burma)',
            'Birmania  Myanmar',
            'Republiek van de Unie van Myanmar',
            'Mianmar (Birmânia)',
        ],
    },
    {
        code: 'NA',
        aliases: [
            'NAM',
            '516',
            'Namibia',
            'Namibie',
            'Namibya',
            'Republiek Namibië',
            'Namibië',
            'Namíbia',
        ],
    },
    { code: 'NR', aliases: ['NRU', '520', 'Nauru', 'Republiek Nauru'] },
    {
        code: 'NP',
        aliases: ['NPL', '524', 'Nepal', 'Népal', 'Federale Democratische Republiek Nepal'],
    },
    {
        code: 'NL',
        aliases: [
            'NLD',
            '528',
            'Niederlande',
            'Netherlands',
            'The Netherlands',
            'Netherlands (Kingdom of the)',
            'Pays-Bas',
            'Países Bajos',
            'Hollanda',
            'Paesi Bassi',
            'Koninkrijk der Nederlanden',
            'Nederland',
            'Países Baixos',
        ],
    },
    {
        code: 'NC',
        aliases: [
            'NCL',
            '540',
            'Neukaledonien',
            'New Caledonia',
            'Nouvelle-Calédonie',
            'Nueva Caledonia',
            'Yeni Kaledonya',
            'Nuova Caledonia',
            'Nieuw-Caledonië',
            'Nova Caledónia',
        ],
    },
    {
        code: 'NZ',
        aliases: [
            'NZL',
            '554',
            'Neuseeland',
            'New Zealand',
            'Nouvelle-Zélande',
            'Nueva Zelanda',
            'Yeni Zelanda',
            'Nuova Zelanda',
            'Nieuw-Zeeland',
            'Nova Zelândia',
        ],
    },
    {
        code: 'NI',
        aliases: ['NIC', '558', 'Nicaragua', 'Nikaragua', 'Republiek Nicaragua', 'Nicarágua'],
    },
    { code: 'NE', aliases: ['NER', '562', 'Niger', 'Níger', 'Nijer', 'Republiek Niger'] },
    {
        code: 'NG',
        aliases: ['NGA', '566', 'Nigeria', 'Nigéria', 'Nijerya', 'Federale Republiek Nigeria'],
    },
    { code: 'NU', aliases: ['NIU', '570', 'Niue', 'Niué'] },
    {
        code: 'NF',
        aliases: [
            'NFK',
            '574',
            'Norfolkinsel',
            'Norfolk Island',
            'Île Norfolk',
            'Isla Norfolk',
            'Norfolk Adası',
            'Isola Norfolk',
            'Norfolk',
            'Ilha Norfolk',
        ],
    },
    {
        code: 'MP',
        aliases: [
            'MNP',
            '580',
            'Nördliche Marianen',
            'Northern Mariana Islands',
            'Îles Mariannes du Nord',
            'Islas Marianas del Norte',
            'Kuzey Mariana Adaları',
            'Isole Marianne Settentrionali',
            'Noordelijke Marianen',
            'Ilhas Marianas do Norte',
        ],
    },
    {
        code: 'MK',
        aliases: [
            'MKD',
            '807',
            'Nordmazedonien',
            'The Republic of North Macedonia',
            'North Macedonia',
            'Macédoine du Nord',
            'Macedonia del Norte',
            'Kuzey Makedonya',
            'Macedonia del Nord',
            'Republiek Noord-Macedonië',
            'Noord-Macedonië',
            'Macedónia do Norte',
        ],
    },
    {
        code: 'NO',
        aliases: [
            'NOR',
            '578',
            'Norwegen',
            'Norway',
            'Norvège',
            'Noruega',
            'Norveç',
            'Norvegia',
            'Koninkrijk Noorwegen',
            'Noorwegen',
        ],
    },
    { code: 'OM', aliases: ['OMN', '512', 'Oman', 'Omán', 'Umman', 'Sultanaat Oman', 'Omã'] },
    {
        code: 'PK',
        aliases: ['PAK', '586', 'Pakistan', 'Pakistán', 'Islamitische Republiek Pakistan', 'Paquistão'],
    },
    { code: 'PW', aliases: ['PLW', '585', 'Palau', 'Palaos', 'Republiek Palau'] },
    {
        code: 'PS',
        aliases: [
            'PSE',
            '275',
            'Staat Palästina',
            'State of Palestine',
            'Palestine',
            'Palestina',
            'Filistin Bölgeleri',
            'Stato di Palestina',
            'Staat Palestina',
            'Territórios palestinos',
        ],
    },
    { code: 'PA', aliases: ['PAN', '591', 'Panama', 'Panamá', 'Republiek Panama'] },
    {
        code: 'PG',
        aliases: [
            'PNG',
            '598',
            'Papua-Neuguinea',
            'Papua New Guinea',
            'Papouasie-Nouvelle-Guinée',
            'Papua Nueva Guinea',
            'Papua Yeni Gine',
            'Papua Nuova Guinea',
            'Onafhankelijke Staat Papoea-Nieuw-Guinea',
            'Papoea-Nieuw-Guinea',
            'Papua-Nova Guiné',
        ],
    },
    { code: 'PY', aliases: ['PRY', '600', 'Paraguay', 'Republiek Paraguay', 'Paraguai'] },
    { code: 'PE', aliases: ['PER', '604', 'Peru', 'Pérou', 'Perú', 'Perù', 'Republiek Peru'] },
    {
        code: 'PH',
        aliases: [
            'PHL',
            '608',
            'Philippinen',
            'Philippines',
            'Filipinas',
            'Filipinler',
            'Filippine',
            'Republiek der Filipijnen',
            'Filipijnen',
        ],
    },
    {
        code: 'PN',
        aliases: [
            'PCN',
            '612',
            'Pitcairninseln',
            'Pitcairn',
            'Pitcairn Islands',
            'Îles Pitcairn',
            'Pitcairn Adaları',
            'Isole Pitcairn',
            'Ilhas Pitcairn',
        ],
    },
    {
        code: 'PL',
        aliases: [
            'POL',
            '616',
            'Polen',
            'Poland',
            'Pologne',
            'Polonia',
            'Polonya',
            'Republiek Polen',
            'Polónia',
        ],
    },
    {
        code: 'PT',
        aliases: ['PRT', '620', 'Portugal', 'Portekiz', 'Portogallo', 'Portugese Republiek'],
    },
    { code: 'PR', aliases: ['PRI', '630', 'Puerto Rico', 'Porto Rico', 'Porto Riko'] },
    { code: 'QA', aliases: ['QAT', '634', 'Katar', 'Qatar', 'Catar', 'Staat Qatar'] },
    { code: 'RE', aliases: ['REU', '638', 'Réunion', 'Reunion', 'Reunión', 'Reunião'] },
    {
        code: 'RO',
        aliases: [
            'ROU',
            '642',
            'Rumänien',
            'Romania',
            'Roumanie',
            'Rumanía',
            'Romanya',
            'Roemeense Republiek',
            'Roemenië',
            'Roménia',
        ],
    },
    {
        code: 'RU',
        aliases: [
            'RUS',
            '643',
            'Russische Föderation',
            'Russland',
            'Russian Federation',
            'Russia',
            'Russie',
            'Rusia',
            'Rusya',
            'Russische Federatie',
            'Rusland',
            'Rússia',
        ],
    },
    { code: 'RW', aliases: ['RWA', '646', 'Ruanda', 'Rwanda', 'Republiek Rwanda'] },
    {
        code: 'SH',
        aliases: [
            'SHN',
            '654',
            'St. Helena',
            'Saint Helena',
            'Sainte-Hélène',
            'Santa Helena, Ascensión y Tristán de Acuña',
            "Sant'Elena, Isola di Ascensione e Tristan da Cunha",
            'Sint-Helena',
            'Santa Helena',
        ],
    },
    {
        code: 'KN',
        aliases: [
            'KNA',
            '659',
            'St. Kitts und Nevis',
            'Saint Kitts and Nevis',
            'Saint-Christophe-et-Niévès',
            'Saint Kitts y Nevis',
            'Saint Kitts ve Nevis',
            'Saint Kitts e Nevis',
            'Federatie Saint Kitts en Nevis',
            'Saint Kitts en Nevis',
            'São Cristóvão e Neves',
        ],
    },
    {
        code: 'LC',
        aliases: [
            'LCA',
            '662',
            'St. Lucia',
            'Saint Lucia',
            'Sainte-Lucie',
            'Santa Lucía',
            'Santa Lucia',
            'Santa Lúcia',
        ],
    },
    {
        code: 'PM',
        aliases: [
            'SPM',
            '666',
            'Saint-Pierre und Miquelon',
            'Saint Pierre and Miquelon',
            'Saint-Pierre-et-Miquelon',
            'San Pedro y Miquelón',
            'Saint Pierre ve Miquelon',
            'Saint Pierre e Miquelon',
            'Saint-Pierre en Miquelon',
        ],
    },
    {
        code: 'VC',
        aliases: [
            'VCT',
            '670',
            'St. Vincent und die Grenadinen',
            'Saint Vincent and the Grenadines',
            'Saint-Vincent-et-les-Grenadines',
            'San Vicente y las Granadinas',
            'Saint Vincent ve Grenadinler',
            'Saint Vincent e Grenadine',
            'Saint Vincent en de Grenadines',
            'São Vicente e Granadinas',
        ],
    },
    { code: 'WS', aliases: ['WSM', '882', 'Samoa', 'Onafhankelijke Staat Samoa'] },
    { code: 'SM', aliases: ['SMR', '674', 'San Marino', 'Saint-Marin', 'Republiek San Marino'] },
    {
        code: 'ST',
        aliases: [
            'STP',
            '678',
            'São Tomé und Príncipe',
            'Sao Tome and Principe',
            'São Tomé-et-Principe',
            'Santo Tomé y Príncipe',
            'São Tomé ve Príncipe',
            'São Tomé e Príncipe',
            'Democratische Republiek São Tomé en Principe',
            'São Tomé en Principe',
        ],
    },
    {
        code: 'SA',
        aliases: [
            'SAU',
            '682',
            'Saudi-Arabien',
            'Saudi Arabia',
            'Arabie Saoudite',
            'Arabia Saudita',
            'Suudi Arabistan',
            'Koninkrijk Saudi-Arabië',
            'Saudi-Arabië',
            'Arábia Saudita',
        ],
    },
    { code: 'SN', aliases: ['SEN', '686', 'Senegal', 'Sénégal', 'Republiek Senegal'] },
    {
        code: 'SC',
        aliases: ['SYC', '690', 'Seychellen', 'Seychelles', 'Seyşeller', 'Republiek der Seychellen'],
    },
    {
        code: 'SL',
        aliases: ['SLE', '694', 'Sierra Leone', 'Sierra Leona', 'Republiek Sierra Leone', 'Serra Leoa'],
    },
    {
        code: 'SG',
        aliases: [
            'SGP',
            '702',
            'Singapur',
            'Singapore',
            'Singapour',
            'Republiek Singapore',
            'Singapura',
        ],
    },
    {
        code: 'SK',
        aliases: [
            'SVK',
            '703',
            'Slowakei',
            'Slovakia',
            'Slovaquie',
            'Eslovaquia',
            'Slovakya',
            'Slovacchia',
            'Slowaakse Republiek',
            'Slowakije',
            'Eslováquia',
        ],
    },
    {
        code: 'SI',
        aliases: [
            'SVN',
            '705',
            'Slowenien',
            'Slovenia',
            'Slovénie',
            'Eslovenia',
            'Slovenya',
            'Republiek Slovenië',
            'Slovenië',
            'Eslovénia',
        ],
    },
    {
        code: 'SB',
        aliases: [
            'SLB',
            '090',
            'Salomonen',
            'Solomon Islands',
            'Îles Salomon',
            'Islas Salomón',
            'Solomon Adaları',
            'Isole Salomone',
            'Salomonseilanden',
            'Ilhas Salomão',
        ],
    },
    {
        code: 'SO',
        aliases: [
            'SOM',
            '706',
            'Somalia',
            'Somalie',
            'Somali',
            'Federale Republiek Somalië',
            'Somalië',
            'Somália',
        ],
    },
    {
        code: 'ZA',
        aliases: [
            'ZAF',
            '710',
            'Südafrika',
            'South Africa',
            'Afrique du Sud',
            'Sudáfrica',
            'Güney Afrika',
            'Sudafrica',
            'Republiek Zuid-Afrika',
            'Zuid-Afrika',
            'África do Sul',
        ],
    },
    {
        code: 'GS',
        aliases: [
            'SGS',
            '239',
            'Südgeorgien und die Südlichen Sandwichinseln',
            'South Georgia and the South Sandwich Islands',
            'Géorgie du Sud-et-les Îles Sandwich du Sud',
            'Georgia del Sur y las Islas Sandwich del Sur',
            'Güney Georgia ve Güney Sandwich Adaları',
            'Georgia del Sud e isole Sandwich meridionali',
            'Zuid-Georgia en de Zuidelijke Sandwicheilanden',
            'Geórgia do Sul e Ilhas Sandwich do Sul',
        ],
    },
    {
        code: 'ES',
        aliases: [
            'ESP',
            '724',
            'Spanien',
            'Spain',
            'Espagne',
            'España',
            'İspanya',
            'Spagna',
            'Koninkrijk Spanje',
            'Spanje',
            'Espanha',
        ],
    },
    {
        code: 'LK',
        aliases: ['LKA', '144', 'Sri Lanka', 'Democratische Socialistische Republiek Sri Lanka'],
    },
    {
        code: 'SD',
        aliases: ['SDN', '729', 'Sudan', 'Soudan', 'Sudán', 'Republiek Soedan', 'Soedan', 'Sudão'],
    },
    { code: 'SR', aliases: ['SUR', '740', 'Suriname', 'Surinam', 'Republiek Suriname'] },
    {
        code: 'SJ',
        aliases: [
            'SJM',
            '744',
            'Svalbard und Jan Mayen',
            'Svalbard and Jan Mayen',
            'Svalbard et Île Jan Mayen',
            'Svalbard y Jan Mayen',
            'Svalbard ve Jan Mayen Adaları',
            'Svalbard e Jan Mayen',
            'Spitsbergen en Jan Mayen',
        ],
    },
    {
        code: 'SZ',
        aliases: [
            'SWZ',
            '748',
            'Eswatini',
            "Royaume d'Eswatini",
            'Esuatini',
            'Svaziland',
            'Koninkrijk Eswatini',
            'Swaziland',
            'Essuatíni',
        ],
    },
    {
        code: 'SE',
        aliases: [
            'SWE',
            '752',
            'Schweden',
            'Sweden',
            'Suède',
            'Suecia',
            'İsveç',
            'Svezia',
            'Koninkrijk Zweden',
            'Zweden',
            'Suécia',
        ],
    },
    {
        code: 'CH',
        aliases: [
            'CHE',
            '756',
            'Schweiz',
            'Switzerland',
            'Suisse',
            'Suiza',
            'İsviçre',
            'Svizzera',
            'Zwitserse Bondsstaat',
            'Zwitserland',
            'Suíça',
        ],
    },
    {
        code: 'SY',
        aliases: [
            'SYR',
            '760',
            'Syrien, Arabische Republik',
            'Syrian Arab Republic',
            'Syrie',
            'República Árabe Siria',
            'Suriye',
            'Siria',
            'Syrische Arabische Republiek',
            'Syrië',
            'Síria',
        ],
    },
    {
        code: 'TW',
        aliases: [
            'TWN',
            '158',
            'Taiwan',
            'Taiwan, Province of China',
            'Taïwan',
            'Taiwán',
            'Tayvan',
            'Repubblica di Cina',
        ],
    },
    {
        code: 'TJ',
        aliases: [
            'TJK',
            '762',
            'Tadschikistan',
            'Tajikistan',
            'Tadjikistan',
            'Tayikistán',
            'Tacikistan',
            'Tagikistan',
            'Republiek Tadzjikistan',
            'Tadzjikistan',
            'Tajiquistão',
        ],
    },
    {
        code: 'TZ',
        aliases: [
            'TZA',
            '834',
            'Tansania, Vereinigte Republik',
            'Tansania',
            'United Republic of Tanzania',
            'Tanzania',
            'République unie de Tanzanie',
            'Tanzanya',
            'Verenigde Republiek Tanzania',
            'Tanzânia',
        ],
    },
    {
        code: 'TH',
        aliases: [
            'THA',
            '764',
            'Thailand',
            'Thaïlande',
            'Tailandia',
            'Tayland',
            'Thailandia',
            'Koninkrijk Thailand',
            'Tailândia',
        ],
    },
    {
        code: 'TL',
        aliases: [
            'TLS',
            '626',
            'Osttimor',
            'Timor-Leste',
            'Timor Est',
            'Democratische Republiek Timor-Leste',
            'Timor Leste',
        ],
    },
    { code: 'TG', aliases: ['TGO', '768', 'Togo', 'Togolese Republiek'] },
    { code: 'TK', aliases: ['TKL', '772', 'Tokelau'] },
    { code: 'TO', aliases: ['TON', '776', 'Tonga', 'Koninkrijk Tonga'] },
    {
        code: 'TT',
        aliases: [
            'TTO',
            '780',
            'Trinidad und Tobago',
            'Trinidad and Tobago',
            'Trinité-et-Tobago',
            'Trinidad y Tobago',
            'Trinidad ve Tobago',
            'Trinidad e Tobago',
            'Republiek Trinidad en Tobago',
            'Trinidad en Tobago',
            'Trindade e Tobago',
        ],
    },
    {
        code: 'TN',
        aliases: [
            'TUN',
            '788',
            'Tunesien',
            'Tunisia',
            'Tunisie',
            'Túnez',
            'Tunus',
            'Republiek Tunesië',
            'Tunesië',
            'Tunísia',
        ],
    },
    {
        code: 'TR',
        aliases: [
            'TUR',
            '792',
            'Türkei',
            'Türkiye',
            'Turkey',
            'Turquie',
            'Turquía',
            'Turchia',
            'Republiek Turkije',
            'Turkije',
            'Turquia',
        ],
    },
    {
        code: 'TM',
        aliases: [
            'TKM',
            '795',
            'Turkmenistan',
            'Turkménistan',
            'Turkmenistán',
            'Türkmenistan',
            'Turkmeense Republiek',
            'Turquemenistão',
        ],
    },
    {
        code: 'TC',
        aliases: [
            'TCA',
            '796',
            'Turks- und Caicosinseln',
            'Turks and Caicos Islands',
            'Îles Turques-et-Caïques',
            'Islas Turcas y Caicos',
            'Turks ve Caicos Adaları',
            'Isole Turks e Caicos',
            'Turks- en Caicoseilanden',
            'Ilhas Turcas e Caicos',
        ],
    },
    { code: 'TV', aliases: ['TUV', '798', 'Tuvalu'] },
    { code: 'UG', aliases: ['UGA', '800', 'Uganda', 'Ouganda', 'Republiek Oeganda', 'Oeganda'] },
    {
        code: 'UA',
        aliases: ['UKR', '804', 'Ukraine', 'Ucrania', 'Ukrayna', 'Ucraina', 'Oekraïne', 'Ucrânia'],
    },
    {
        code: 'AE',
        aliases: [
            'ARE',
            '784',
            'Vereinigte Arabische Emirate',
            'United Arab Emirates',
            'UAE',
            'Émirats Arabes Unis',
            'Emiratos Árabes Unidos',
            'Birleşik Arap Emirlikleri',
            'Emirati Arabi Uniti',
            'Verenigde Arabische Emiraten',
            'Emirados Árabes Unidos',
        ],
    },
    {
        code: 'GB',
        aliases: [
            'GBR',
            '826',
            'Vereinigtes Königreich',
            'Großbritannien',
            'United Kingdom',
            'UK',
            'Great Britain',
            'Royaume-Uni',
            'Reino Unido',
            'Birleşik Krallık',
            'Regno Unito',
            'Verenigd Koninkrijk van Groot-Brittannië en Noord-Ierland',
            'Verenigd Koninkrijk',
        ],
    },
    {
        code: 'US',
        aliases: [
            'USA',
            '840',
            'Vereinigte Staaten von Amerika',
            'Vereinigte Staaten',
            'United States of America',
            'United States',
            'U.S.A.',
            'US',
            'U.S.',
            "États-Unis d'Amérique",
            'Estados Unidos',
            'ABD',
            'A.B.D.',
            'Amerika Birleşik Devletleri',
            'Birleşik Devletler',
            'Amerika',
            "Stati Uniti d'America",
            'Verenigde Staten van Amerika',
            'Verenigde Staten',
            'Estados Unidos da América',
        ],
    },
    {
        code: 'UM',
        aliases: [
            'UMI',
            '581',
            'United States Minor Outlying Islands',
            'Îles mineures éloignées des États-Unis',
            'Islas Ultramarinas Menores de los Estados Unidos',
            'ABD Uzak Adaları',
            'Isole minori esterne degli Stati Uniti',
            'Amerikaanse Kleinere Afgelegen Eilanden',
            'Ilhas Distantes dos EUA',
        ],
    },
    { code: 'UY', aliases: ['URY', '858', 'Uruguay', 'Oostelijke Republiek Uruguay', 'Uruguai'] },
    {
        code: 'UZ',
        aliases: [
            'UZB',
            '860',
            'Usbekistan',
            'Uzbekistan',
            'Ouzbékistan',
            'Uzbekistán',
            'Özbekistan',
            'Republiek Oezbekistan',
            'Oezbekistan',
            'Uzbequistão',
        ],
    },
    { code: 'VU', aliases: ['VUT', '548', 'Vanuatu', 'Republiek Vanuatu'] },
    { code: 'VE', aliases: ['VEN', '862', 'Venezuela', 'Bolivariaanse Republiek Venezuela'] },
    {
        code: 'VN',
        aliases: ['VNM', '704', 'Vietnam', 'Socialistische Republiek Vietnam', 'Vietname'],
    },
    {
        code: 'VG',
        aliases: [
            'VGB',
            '092',
            'Britische Jungferninseln',
            'Virgin Islands, British',
            'Îles vierges britanniques',
            'Islas Vírgenes británicas',
            'Britanya Virjin Adaları',
            'Isole Vergini Britanniche',
            'Britse Maagdeneilanden',
            'Ilhas Virgens Britânicas',
        ],
    },
    {
        code: 'VI',
        aliases: [
            'VIR',
            '850',
            'Amerikanische Jungferninseln',
            'Virgin Islands, U.S.',
            'Îles vierges américaines',
            'Islas Vírgenes de los Estados Unidos',
            'ABD Virjin Adaları',
            'Isole Vergini Americane',
            'Amerikaanse Maagdeneilanden',
            'Ilhas Virgens Americanas',
        ],
    },
    {
        code: 'WF',
        aliases: [
            'WLF',
            '876',
            'Wallis und Futuna',
            'Wallis and Futuna',
            'Wallis-et-Futuna',
            'Wallis y Futuna',
            'Wallis ve Futuna Adaları',
            'Wallis e Futuna',
            'Wallis en Futuna',
        ],
    },
    {
        code: 'EH',
        aliases: [
            'ESH',
            '732',
            'Westsahara',
            'Western Sahara',
            'Sahara occidental',
            'Sahara Occidental',
            'Batı Sahara',
            'Sahara Occidentale',
            'Westelijke Sahara',
            'Saara Ocidental',
        ],
    },
    { code: 'YE', aliases: ['YEM', '887', 'Jemen', 'Yemen', 'Yémen', 'Republiek Jemen', 'Iémen'] },
    {
        code: 'ZM',
        aliases: ['ZMB', '894', 'Sambia', 'Zambia', 'Zambie', 'Zambiya', 'Republiek Zambia', 'Zâmbia'],
    },
    {
        code: 'ZW',
        aliases: [
            'ZWE',
            '716',
            'Simbabwe',
            'Zimbabwe',
            'Zimbabue',
            'Zimbabve',
            'Republiek Zimbabwe',
            'Zimbábue',
        ],
    },
    {
        code: 'AX',
        aliases: [
            'ALA',
            '248',
            'Åland',
            'Åland Islands',
            'Aland Islands',
            'Islas Åland',
            'Åland Adaları',
            'Isole Åland',
            'Ilhas Åland',
        ],
    },
    {
        code: 'BQ',
        aliases: [
            'BES',
            '535',
            'Bonaire',
            'Bonaire, Sint Eustatius and Saba',
            'Bonaire, Saint-Eustache et Saba',
            'Bonaire, San Eustaquio y Saba',
            'Karayip Hollanda',
            'Isole BES',
            'Bonaire, Sint Eustatius en Saba',
            'Países Baixos Caribenhos',
        ],
    },
    { code: 'CW', aliases: ['CUW', '531', 'Curaçao'] },
    { code: 'GG', aliases: ['GGY', '831', 'Guernsey', 'Guernesey'] },
    {
        code: 'IM',
        aliases: [
            'IMN',
            '833',
            'Insel Man',
            'Isle of Man',
            'Île de Man',
            'Isla de Man',
            'Man Adası',
            'Isola di Man',
            'Man Eiland',
            'Ilha de Man',
        ],
    },
    { code: 'JE', aliases: ['JEY', '832', 'Jersey'] },
    { code: 'ME', aliases: ['MNE', '499', 'Montenegro', 'Monténégro', 'Karadağ'] },
    {
        code: 'BL',
        aliases: [
            'BLM',
            '652',
            'Saint-Barthélemy',
            'Saint Barthélemy',
            'Saint Barthelemy',
            'São Bartolomeu',
        ],
    },
    {
        code: 'MF',
        aliases: [
            'MAF',
            '663',
            'Saint-Martin',
            'Saint Martin (French part)',
            'Saint-Martin (partie française)',
            'Saint Martin (francesa)',
            'Saint Martin',
            'Sint-Maarten (Frans deel)',
            'Sint-Maarten (Franse Antillen)',
            'Collectiviteit van Sint-Maarten',
            'São Martinho',
        ],
    },
    {
        code: 'RS',
        aliases: [
            'SRB',
            '688',
            'Serbien',
            'Serbia',
            'Serbie',
            'Sırbistan',
            'Republiek Servië',
            'Servië',
            'Sérvia',
        ],
    },
    {
        code: 'SX',
        aliases: [
            'SXM',
            '534',
            'Sint Maarten',
            'Sint Maarten (Dutch part)',
            'Saint-Martin (partie néerlandaise)',
            'Sint Maarten (neerlandesa)',
            'Sint-Maarten',
            'Sint Maarten (Nederlands deel)',
            'Land Sint Maarten',
            'São Martinho',
        ],
    },
    {
        code: 'SS',
        aliases: [
            'SSD',
            '728',
            'Südsudan',
            'South Sudan',
            'Soudan du Sud',
            'Sudán del Sur',
            'Güney Sudan',
            'Sudan del Sud',
            'Republiek Zuid-Soedan',
            'Zuid-Soedan',
            'Sudão do Sul',
        ],
    },
    { code: 'XK', aliases: ['XKK', '983', 'Kosovo', 'Kosova', 'Republiek Kosovo'] },
];
//# sourceMappingURL=countries.js.map